<template>
  <el-dialog :visible.sync="visibleSync" width="520px" :show-close="true">
    <div slot="title">Điều phối công việc</div>
    <div>
      <p>Vui lòng chọn người để gán tác vụ cho người phụ trách</p>
      <el-select filterable clearable v-model="assignee_id" class="w-100" placeholder="Chọn người phụ trách">
        <el-option v-for="u in qcAssignees" :key="u.id" :label="`${u.id + 100000} - ${u.name}`" :value="u.id" />
      </el-select>
      <div class="text-danger mt-2" v-if="showError">Không được bỏ trống trường thông tin</div>
    </div>
    <div slot="footer" class="dialog-footer d-flex justify-content-end">
      <button class="mt-2 btn btn-secondary font-weight-bold mr-2" @click="visibleSync = false">
        <i class="fas fa-times"></i> Đóng
      </button>

      <button class="mt-2 btn btn-primary font-weight-bold" @click="confirm" :disabled="loading">
        <span v-if="loading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
        <i v-else class="fas fa-check"></i> 
        {{ loading ? 'Đang xử lý...' : 'Gán tác vụ' }}
      </button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'AssignDialog',
  props: {
    visible: { type: Boolean, default: false },
    qcAssignees: { type: Array, default: () => [] },
    selectedIds: { type: Array, default: () => [] },
  },
  data() {
    return { visibleSync: this.visible, assignee_id: '', showError: false, loading: false };
  },
  watch: { 
    visible(v) { 
      this.visibleSync = v; 
      if (!v) this.reset(); // Reset when dialog closes
    }, 
    visibleSync(v) { 
      this.$emit('update:visible', v); 
    } 
  },
  methods: {
    confirm() {
      if (!this.assignee_id) { this.showError = true; return; }
      if (this.loading) return; // Prevent double submit
      
      this.loading = true;
      const user = (this.qcAssignees || []).find(u => u.id === this.assignee_id) || {};
      this.$emit('confirm', { 
        assignee_id: this.assignee_id, 
        assignee_name: user.name || '',
        loading: this.loading 
      });
    },
    reset() {
      this.assignee_id = '';
      this.showError = false;
      this.loading = false;
    }
  }
};
</script>

<style scoped>
</style>


